'use client'

import { useFormatter } from 'next-intl'

export default function ClientDatetime({
  datetime,
  formatType = 'deadline',
}: {
  datetime: string
  formatType?: string
}) {
  const format = useFormatter()

  return format.dateTime(new Date(datetime), formatType)
}
